import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
                {appInfo.title}
              </h2>
              <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                {appInfo.desc}
              </p>

              <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-8">
                {appInfo.features.map((feature, i) => (
                  <span key={i} className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50 bg-background-50/15 px-3 py-1.5 rounded-full">
                    <i className="ri-check-line text-sm"></i>
                    {feature}
                  </span>
                ))}
              </div>

              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                立即开始阅读
              </a>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end p-8 md:p-0 lg:pr-0">
              <div className="relative w-full max-w-[420px]">
                <div className="relative rounded-t-2xl lg:rounded-tr-2xl lg:rounded-tl-none overflow-hidden border-4 border-background-50/30" style={{ aspectRatio: '9/16', maxHeight: '500px' }}>
                  <div className="absolute inset-0 bg-background-50 p-3 flex flex-col">
                    <div className="flex items-center justify-between mb-3 pb-2 border-b border-background-200">
                      <span className="text-xs font-semibold text-foreground-800">韩漫网 · 下拉式阅读</span>
                      <span className="text-[10px] text-foreground-400">www.hanman.example.com</span>
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                      <div className="bg-background-100 rounded h-3 w-3/4"></div>
                      <div className="bg-background-100 rounded h-3 w-full"></div>
                      <div className="bg-background-100 rounded h-3 w-5/6"></div>
                      <div className="bg-background-100 rounded h-3 w-full"></div>
                      <div className="bg-background-100 rounded h-3 w-2/3"></div>
                      <div className="mt-2 bg-background-200 rounded h-40 w-full"></div>
                      <div className="bg-background-100 rounded h-3 w-full"></div>
                      <div className="bg-background-100 rounded h-3 w-5/6"></div>
                      <div className="bg-background-100 rounded h-3 w-full"></div>
                      <div className="bg-background-100 rounded h-3 w-3/4"></div>
                      <div className="bg-background-100 rounded h-3 w-2/3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}